import { get, getAll, toggleBooleanAttribute } from './utility';

get( '.site-header__burger' ).addEventListener( 'click', ( e ) => {
    const button = e.currentTarget;
    const controls = button.getAttribute( 'aria-controls' );
    const menu = document.getElementById( controls );
    const mobMenu = get( '#menu-main-menu-1', menu );
    jQuery( mobMenu ).slideToggle();
    toggleBooleanAttribute( button, 'aria-expanded' );
    menu.classList.toggle( 'toggled' );
    toggleBooleanAttribute( mobMenu, 'aria-expanded' );
} );


document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.querySelectorAll("form.woocommerce-product-search [type=search]");

    searchInput.forEach(function (field) {

        field.addEventListener("input", function () {
            const scrollY = window.scrollY;
            requestAnimationFrame(() => {
                window.scrollTo(0, scrollY);
            });
        });
    })
});
